import type { BasketItem } from '@virginexperiencedays/basket';

type SubTotalValuesType = (items: BasketItem[]) => {
  /**
   * The total number of items in the basket
   */
  totalItems: number;
  /**
   * The total cost of all items in the basket
   */
  totalCost: number;
  /**
   * The total savings of all items in the basket
   */
  totalSavings: number;
  /**
   * Whether discounts only apply to some items in the basket
   */
  isPartialDiscount: boolean;
};

export const subtotalValues: SubTotalValuesType = (items) => {
  let discountedItemsCount = 0;

  const result = items?.reduce(
    (totals, item) => {
      const { discountedPrice = 0, displayPrice, qty } = item;

      const effectivePrice =
        discountedPrice && discountedPrice !== displayPrice ? discountedPrice : displayPrice;
      const itemSavings = displayPrice - discountedPrice;

      totals.totalItems += qty;
      totals.totalCost += qty * effectivePrice;
      totals.totalSavings += qty * itemSavings;

      if (discountedPrice !== displayPrice) {
        discountedItemsCount += 1;
      }

      return totals;
    },
    { totalItems: 0, totalCost: 0, totalSavings: 0 }
  );

  const isPartialDiscount = discountedItemsCount !== items.length;

  return { ...result, isPartialDiscount };
};
